import { useLocation, useNavigate } from "react-router-dom"
import Input, { required, submitForm, useInput } from "../../components/input"
import LoadingButton from "../../components/LoadingButton"
import { useState } from "react"
import { api } from "../../env"

export function ResetPassword() {

    const navigate = useNavigate()
    const code = new URLSearchParams(useLocation().search).get('code')

    const [loading, setLoading] = useState(false)

    const resetForm = {
        // TODO Password checks
        password: useInput("Password", "lock_open", "password", [required]),
        repeatPassword: useInput("Repeat Password", "lock", "password", [required]),
    }
    
    const handleReset = () => {
        let credentials = submitForm(resetForm)
        if (!credentials) return
        setLoading(true)
        api.post('accounts/password/recovery/confirm', {code, newPassword: credentials?.password ?? ''})
            .then(_ => {
                setLoading(false)
                navigate('/')
            })        
            .catch(err => {
                setLoading(false)
            })
    }

    return(
        <div className="flex columns gap-xs showing" style={{width: 'clamp(200px, 85%, 320px)', padding: '64px 0'}}>
            <p className="section-title">Reset Password</p>
            <Input state={resetForm.password} />
            <Input state={resetForm.repeatPassword} />
            <LoadingButton className={'solid-accent large'} onClick={handleReset} label={'Set New Password'} loading={loading}/>
        </div>
    )
}